import { render } from "./ProfitLossSports.vue?vue&type=template&id=33c25a9d"
import script from "./ProfitLossSports.vue?vue&type=script&lang=js"
export * from "./ProfitLossSports.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__